import { render } from "./RoomsIcon.vue?vue&type=template&id=7cd67c6a&scoped=true"
import script from "./RoomsIcon.vue?vue&type=script&lang=js"
export * from "./RoomsIcon.vue?vue&type=script&lang=js"

import "./RoomsIcon.vue?vue&type=style&index=0&id=7cd67c6a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cd67c6a"]])

export default __exports__